import React, { useState, useRef } from "react";
import withPortal from "jd-library/withPortal";
import Modal from "jd-library/Modal";
import "./selling-price-modal.scss";
import { discountCalculator, isSafari } from "../../utills";
import format from "date-fns/format";
import historyHandler from "jd-library/historyHandler";

const SingleComissionList = (props) => {
  const discountPercent = discountCalculator(
    props.data.sellingPrice,
    props.data.mrp
  );

  const displayDate = (date) => {
    if(date){
      let newDate = new Date(date);
      return format(newDate, "dd MMM yy");
    }
  };
  return (
    <>
      <div className="single-comission-holder">
        {/* <div className="com-data">
          <span className="com-data-left">Batch Creation Date:</span>
          <span className="">22 May 21</span>
        </div> */}
        <div className="com-data">
          <span className="com-data-left">Price :</span>
          <span className="price-selling">₹{props.data.mrp}</span> &nbsp;
          <span>
            <b>₹{props.data.sellingPrice}</b>&nbsp;
          </span>
          <span className="discount">{discountPercent}%OFF</span>
        </div>
        <div className="com-data">
          <span className="com-data-left">{props.data.batchCreationDate?'Batch Creation Date':''}</span>
          <span className="">{displayDate(props.data.batchCreationDate)}</span>
        </div>
      </div>
    </>
  );
};

const SinglePriceList = (props) => {
  const { mrp, sellingPrice } = props.data;
  const discountPercent = discountCalculator(sellingPrice, mrp);
  return (
    <div className="price-holder">
      <span className="price-subtitle">Price : &nbsp;</span>
      <span className="price-selling">₹{mrp} </span>&nbsp;
      <span>
        <b>₹{sellingPrice}</b>&nbsp;
      </span>
      <span className="discount">{discountPercent}%OFF</span>
    </div>
  );
};

const SellingPriceModal = (props) => {
  const [scrolled, setScroll] = useState(false);
  const scrollRef = useRef(null);

  const handleScroll = () => {
    const isScrolled = scrollRef.current.scrollTop > 10;
    if (isScrolled !== scrolled) {
      setScroll(isScrolled);
    }
  };

  return (
    <div>
      <Modal
        settings={{
          modalId: "center-btn",
          class: "comission-action-modal",
          variant: "action",
        }}
        onHidden={() => {
          props.onHidden();
        }}
      >
        <Modal.CloseIcon />
        <Modal.Header
          className={`heading-txt ${scrolled ? "commission-modl-shadow" : ""}`}
        >
          Confirm Selling Price
        </Modal.Header>
        <Modal.Body className="comission-body-holder">
          <div
            className="comission-body-container"
            ref={scrollRef}
            onScroll={handleScroll}
          >
            <div className="subtitle-holder">
              <div className="image-holder">
                <img src={props.data.actualImageUrl} alt="Product icon" />
              </div>
              <div>
                <span className="selling-subtitle">
                  {props.data.productName} &nbsp;
                </span>
                {props.data.batches.length === 1 ? (
                  <SinglePriceList data={props.data.batches[0]} />
                ) : null}
              </div>
            </div>
            {props.data.batches.length > 1
              ? props.data.batches.map((cur) => {
                  return <SingleComissionList data={cur} />;
                })
              : null}
          </div>
        </Modal.Body>
        <Modal.CenterButton
          className="fs-sb"
          variant="primary"
          showLoader ={props.showBtnLoader}
          onClick={() => {
            if(props.isMobile){
              historyHandler.closeCurrent();
              let safari = isSafari();
              if((!props.isChrome && safari) || props.isIphone) {
                 setTimeout(() => {
                   historyHandlerndler.closeCurrent();
                 }, 100);
              }
           }      
            props.confirmClick();
          }}
        >
          Confirm
        </Modal.CenterButton>
      </Modal>
    </div>
  );
};
export default withPortal(SellingPriceModal);
